import { BadgeCheck, Star } from "lucide-react";

const COND_COLORS = {
  A: "bg-emerald-500/15 text-emerald-700 border-emerald-500/40",
  B: "bg-lime-500/15 text-lime-700 border-lime-500/40",
  C: "bg-yellow-500/15 text-yellow-700 border-yellow-500/40",
  D: "bg-amber-500/15 text-amber-700 border-amber-500/40",
  E: "bg-orange-500/15 text-orange-700 border-orange-500/40",
  F: "bg-red-500/15 text-red-700 border-red-500/40",
  G: "bg-red-700/20 text-red-700 border-red-700/50",
};

export const ConditionBadge = ({ code, testId }) =>
  code ? (
    <span data-testid={testId} title="Satıcı beyanı" className={`inline-flex items-center rounded-full border px-1.5 py-0.5 font-mono text-xs ${COND_COLORS[code] || ""}`}>
      Kondisyon {code}
    </span>
  ) : null;

export const StateBadge = ({ state }) => (
  <span className={`rounded px-1.5 py-0.5 text-xs font-medium ${state === "new" ? "bg-[#0071e3]/20 text-sky-700" : "bg-black/[0.05] text-zinc-700"}`}>
    {state === "new" ? "Sıfır" : "İkinci el"}
  </span>
);

export const VerifiedTick = ({ show }) =>
  show ? <BadgeCheck data-testid="verified-tick" aria-label="Onaylı hesap" className="inline h-4 w-4 text-[#0071e3]" /> : null;

const STAR_SIZE = { 3: "h-3 w-3", 4: "h-4 w-4", 5: "h-5 w-5", 6: "h-6 w-6" };

export function Stars({ value = 0, size = 4, onChange, testId }) {
  return (
    <span className="inline-flex gap-0.5" data-testid={testId}>
      {[1, 2, 3, 4, 5].map((n) => (
        <Star
          key={n}
          data-testid={onChange ? `${testId}-${n}` : undefined}
          onClick={onChange ? () => onChange(n) : undefined}
          className={`${STAR_SIZE[size]} ${onChange ? "cursor-pointer" : ""} ${n <= Math.round(value) ? "fill-[#0071e3] text-[#0071e3]" : "text-zinc-400"}`}
        />
      ))}
    </span>
  );
}

const COMPAT = {
  verified: { label: "Doğrulanmış uyumlu", cls: "bg-emerald-500/15 text-emerald-700 border-emerald-500/50" },
  possible: { label: "Olası uyumlu / doğrulanamadı", cls: "bg-yellow-500/15 text-yellow-700 border-yellow-500/50" },
  incompatible: { label: "Uyumsuz", cls: "bg-red-500/15 text-red-700 border-red-500/50" },
  unchecked: { label: "Kontrol edilecek önceki parça yok", cls: "bg-black/[0.03] text-zinc-500 border-black/[0.08]" },
};

export const CompatBadge = ({ status, testId }) => {
  const c = COMPAT[status] || COMPAT.unchecked;
  return <span data-testid={testId} className={`inline-flex rounded-full border px-2 py-0.5 text-xs font-medium ${c.cls}`}>{c.label}</span>;
};
